//import React, { forwardRef, useState } from 'react'
//import {Input, Dropdown} from 'semantic-ui-react'

const getMondayDate=( date )=> {
    var day = date.getDay() || 7;  
    if( day !== 1 ) 
        date.setHours(-24 * (day - 1)); 
    return date;
}
const getThursdayDate=date=>{
    const day=date.getDay() || 7
    const newDate=new Date(date)
    if(day> 4)
        newDate.setHours(-24 * (day-4))
    else if(day<4)
        newDate.setHours(-24 * (7-(4-day)))
    return newDate
}
const getFirstDayOfMonth=()=>{
    const d=new Date()
    return new Date(d.getFullYear(), d.getMonth(), 1)
}

const getFirstDayOfYear=()=>{
    const d=new Date()
    return new Date(d.getFullYear(), 0, 1)
}
const getFirstDayOfTemp=()=>{
    const d=new Date()
    return new Date(d.getFullYear(), 9, 1)
}
const today=()=>{
    const now=new Date(Date.now())
    const tdy= new Date(now.getFullYear(), now.getMonth(), now.getDate())
    return tdy
}
const GetDayDifference=(Later, Earlier)=>{
    const diff=(Later-Earlier) / (1000 * 3600 * 24)
    return Math.round(diff)
}
const addDays=(date, days)=>{
    const newDate=new Date(date)
    newDate.setHours(24*days)
    return newDate
}
const getDayAndMonthString=(date)=>{
    const string=`${date.getDate()}-${date.getMonth()+1}`
    return string
}
const parseDate=(stringDate)=>{
    const timezoneOffset=new Date().getTimezoneOffset()
    const timezone=timezoneOffset>=0 
    ? 
    `-${(timezoneOffset/60).toString().padStart(2, '0')}:00`
    :
    `+${(timezoneOffset/60).toString().padStart(2, '0')}:00`
    return new Date(Date.parse(`${stringDate}T00:00:00.000${timezone}`))
}
/*
const SpecificDateRange=forwardRef((props, ref)=>{
    const [dateFilter, dateFilterChange] = useState("semana")
    const [firstDate, firstDateChange] = useState('')
    const [firstDateStr, firstDateStrChange] = useState('')
    const [secondDate, secondDateChange] = useState('')
    const [secondDateStr, secondDateStrChange] = useState('')

    const handleDateFilterChange=(e, {value})=>{
        dateFilterChange(value)
    }
    const handleSpecificDateChange=(e, {name, value})=>{
        const date=parseDate(value)
        if (name==="firstDate"){
            firstDateChange(date)
            firstDateStrChange(value)
        } else {
            secondDateChange(date)
            secondDateStrChange(value)
        }
    }
    const filterByDate=(dbReference)=>{
        console.log(dbReference)
        if(dateFilter==='specificDateRange'){
            if(firstDate!=='' && secondDate!==''){
                return filterSpecificDates(dbReference)
            }else {
                return dbReference
            }
        }else if(dateFilter==='mes'){
            return filterEsteMes(dbReference)
        }else {
            return filterEstaSemana(dbReference)
        }
    }
    const filterEstaSemana=dbReference=>{
        let first = getThursdayDate()
        return dbReference.where('fecha', '>=', first)
    }
    const filterEsteMes=dbReference=>{
        let first = getFirstDayOfMonth()
        return dbReference.where('fecha', '>=', first)
    }
    const filterSpecificDates=dbReference=>{
        return dbReference.where('fecha', '>=', firstDate).where('fecha', '<=', addDays(secondDate, 1))
    }
    return(
        <div>
        <Dropdown
            ref={ref}
            selection
            options={[
                {key:1, text:'Esta Semana', value:'semana'},
                {key:2, text:'Este Mes', value:'mes'},
                {key:3, text:'Fechas específicas', value:'specificDateRange'},
            ]}
            name='dateFilter'
            value={dateFilter}
            onChange={handleDateFilterChange}
        />
        {
            dateFilter==='specificDateRange'
                ?
            <>
            <div>
                <h3>Del</h3>
                <Input
                    type='date'
                    value={firstDateStr}
                    name='firstDate'
                    onChange={handleSpecificDateChange}
                />
            </div>
            <div>
                <h3>Al</h3>
                <Input
                    type='date'
                    value={secondDateStr}
                    name='secondDate'
                    onChange={handleSpecificDateChange}
                />
            </div>
            </>
            :null
        }
        </div>
    )
})
*/
const Utilities={
    getMondayDate,
    getFirstDayOfMonth,
    getFirstDayOfYear,
    getFirstDayOfTemp,
    today,
    GetDayDifference,
    getThursdayDate,
    addDays,
    parseDate,
    getDayAndMonthString,
}

export default Utilities